import { Popover } from 'antd';

const ActQA = ({ text }) => {
  return (
    <Popover content={text} title={null} trigger="click">
      <i className="qaIcon" style={{ verticalAlign: '-0.01rem' }} />
    </Popover>
  );
};
export default ActQA;
